module.exports = __webpack_public_path__ + "img/calc-guide.96725522.png";